<script setup>
import { useHead } from '@unhead/vue'

// Components
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import BaseModal from "@/components/base_modal.vue";
import ToastContainer from "@/components/toast_container.vue";

let robotsMeta = { name: 'robots', content: 'index, follow' }
if (!import.meta.env.VITE_APP_ENV !== 'production') {
  robotsMeta = { name: 'robots', content: 'noindex, nofollow' }
}

useHead({
  htmlAttrs: { lang: 'en-US' }, // BCP 47 language code
  meta: [
    robotsMeta
  ]
})
</script>

<template>
  <div class="flex flex-col min-h-screen bg-white text-black dark:bg-black dark:text-white">
    <Header />
    <RouterView />
    <Footer />
    <BaseModal />
    <ToastContainer />
  </div>
</template>

<style lang="scss" scoped>
</style>
